// extracted by mini-css-extract-plugin
module.exports = {"CommentSection":"CommentSection_CommentSection__AgE5_"};